export const TIPO_TARJETA_BANCARIA = {
  CREDITO: 1,
  DEBITO: 2,
  PREPAGO: 3,
} as const

export type TipoTarjetaBancariaType =
  (typeof TIPO_TARJETA_BANCARIA)[keyof typeof TIPO_TARJETA_BANCARIA]
